__turbopack_context__.v({
  "body": "global-email-signup-module-scss-module__FAmxeq__body",
  "button": "global-email-signup-module-scss-module__FAmxeq__button",
  "emailInput": "global-email-signup-module-scss-module__FAmxeq__emailInput",
  "emailLabel": "global-email-signup-module-scss-module__FAmxeq__emailLabel",
  "errorMessage": "global-email-signup-module-scss-module__FAmxeq__errorMessage",
  "form": "global-email-signup-module-scss-module__FAmxeq__form",
  "inputContainer": "global-email-signup-module-scss-module__FAmxeq__inputContainer",
  "noError": "global-email-signup-module-scss-module__FAmxeq__noError",
  "successMessage": "global-email-signup-module-scss-module__FAmxeq__successMessage",
  "svg": "global-email-signup-module-scss-module__FAmxeq__svg",
});
